<template>
  <div class="card config-wrapper">
      <div  class="row">
          <div class="card-header col-12 mt-3">
              <h5 class="card-title text-center">Configurator</h5>
              <hr>
          </div>
      </div>
      <div class="row" style="position: relative; top: -20px">
          <div class="col-6 border-right">
              <div class="card-body">
                  <div class="my-3">
                    <BasicTextInput label="Search" placeholder="Search..." v-model="search" class="mb-2" @change="searchChange"/>
                    <checkbox label="Search All" v-model="isSearchAll" style="float:right; margin-top: -75px;" @change="selectAllChanged"/>
                  </div>

                  <div class="my-3">
                      <div class="form-group">
                          <label><b>Configurator</b></label>
                          <select class="form-control"
                                  :disabled="isSearchAll"
                                  @change="handleSelectedConfigChange"
                                  v-model="selectedConfiguratorId">
                              <option v-for="item in configuratorOptions" :key="item.Id" :value="item.Id">{{ item.ConfiguratorName }}</option>
                          </select>
                          <i class="fa fa-chevron-down"></i>
                      </div>
                  </div>

                  <div class="mb-3">
                      <label><b>Category</b></label>
                      <div class="form-group">
                          <select class="form-control"
                                  :disabled="isSearchAll"
                                  v-model="selectedCategoryId"
                                  @change="getConfiguratorProducts">
                              <option v-for="item in configuratorCategoryOptions" :key="item.Id" :value="item.Id">{{ item.Name }}</option>
                          </select>
                          <i class="fa fa-chevron-down"></i>
                      </div>
                  </div>

                  <div class="configurator-group-wrapper">

                        <div class="px-2 mb-1 group-container" v-for="group in configuratorProductsFiltered" :key="group.Id">
                            <b>{{group.Name}}</b>
                            <div class="px-3 mx-0 mb-1 product-container pointer" @click="handleProductClicked(product)" v-for="(product, index) in group.Products" :key="product + product.Id + index" >
                                {{product.Description}}
                            </div>
                        </div>
                  </div>
              </div>
          </div>
          <div class="col-6">
              <div class="card-body">
                    <!--
                  <div class="configurator-name-wrapper d-flex">
                      <span><b style="fontSize: 36px">{{capitalize(configuratorName)}}</b>
                        <span style="position:relative; left:30px; top:5px;">&nbsp;{{configuratorAuthorName}}</span>
                      </span>
                  </div>
                -->

                  <div class="product-datagrid-wrapper" style="margin-top: 15px">
                      <ConfiguratorDataGrid 
                        :key="dataSourceUpdateKey" 
                        @orderlineUpdateComplete="handleAddProducts" 
                        @checkAndUpdateChildRowsQuantity="checkAndUpdateChildRowsQuantity" 
                        :addToOrderlinesWasClicked="addToOrderlinesWasClicked" 
                        :dataSource="dataSource">
                      </ConfiguratorDataGrid>
                  </div>
                  <div class="row p-2 mx-2 justify-content-between align-items-center">
                      <div ><b class="total">Total:</b></div>
                      <div>{{formatCurrency(totalRetail)}}</div> 
                  </div>
                  <div class="row">
                      <div @click="clearDataSource()" class="btn btn-secondary col btn-block m-2">Start Over</div>
                      <div @click="handleAddToOrderlinesClicked" class="btn btn-secondary col btn-block m-2">Add To Order</div> 
                  </div>
                  
              </div>
          </div>
      </div>
  </div>
</template>

<script>
  import { mapState }   from 'vuex';
  import { DealerService }  from '@/services';
  import ConfiguratorDataGrid   from '@/components/ConfiguratorDataGrid';
  import LogoDropdown  from '@/components/LogoDropdown';
  import Checkbox from './inputComponents/Checkbox.vue';

  function categorySort (a,b) {
    if (a.Id < b.Id) return -1;
    if (a.Id > b.Id) return 1;
    return 0;
  }

  export default {
      name: "ConfiguratorV2",

      components: {
         ConfiguratorDataGrid,
         LogoDropdown,
         Checkbox,
      },
      data: () => {
          return {
              secondaryGroups: [{group: 'Group1', products:['Prod1', 'Prod2']}, {group: 'Group2', products: ['ProdA', 'ProdB']}],
              configurators: [],
              dataSource: [],
              dataSourceUpdateKey: 0,
              addToOrderlinesWasClicked: false,
              configuratorProducts: [],
              configuratorProductsFiltered: [],
              selectedCategoryId: null,
              selectedMemberId: null,
              selectedConfiguratorId: null,
              thumbnailURL: null,
              search: '',
              configuratorOptions: [],
              allProducts: [],
              isSearchAll: false
          }
      },
      computed: {
          ...mapState(['currentUser']),
          totalRetail(){
              let total = 0;
              this.dataSource.forEach(item => {
                  if(!item.RetailAmount) return;
                  total += item.RetailAmount * item.Quantity;
              })
              return total;
          },
          memberOptions(){
              let index = this.configurators.map(config => config.Id).indexOf(this.selectedConfiguratorId);
              if (index < 0) return [];
              return this.configurators[index].ConfiguratorMembers.map(member => {
                  return {
                      Id: member.Id,
                      Name: member.Name,
                      AuthorName: member.AuthorName
                  }
              })
          },
          configuratorCategoryOptions(){
            let configuratorIndex = this.configuratorOptions.map(config => config.Id).indexOf(this.selectedConfiguratorId);

            if (configuratorIndex < 0) {
                return
            }

            const member = this.configuratorOptions[configuratorIndex].member

            return member.Categories.sort(categorySort);
          },
          configuratorName(){
              if(!this.selectedConfiguratorId) return "";
              let index = this.configurators.map(config => config.Id).indexOf(this.selectedConfiguratorId)
              if(index < 0) return "";
              return this.configurators[index].ConfiguratorName;
          },
          configuratorAuthorName(){
            return "";
          }
      },
      methods: {
          selectAllChanged() {
            if (this.isSearchAll) {
                this.selectedConfiguratorId = -1;
                this.selectedCategoryId = -1;
            }
            else {
                this.selectedConfiguratorId = this.configuratorOptions[0].Id;
                this.handleSelectedConfigChange();
            }

            this.search = '';
            this.configuratorProductsFiltered = [];
          },
          searchChange() {
            const filtered = []
            const searchText = this.search?.toLowerCase() ?? ''

            const configurators = this.isSearchAll ? this.allProducts : this.configuratorProducts;

            for ( const group of configurators ) {
                const working = {
                    Id: group.Id,
                    Name: group.Name,
                    Products: []
                }

                for ( const product of group.Products ) {
                    if (product.Description.toLowerCase().includes(searchText)) {
                        working.Products.push(product)
                    }
                }

                if (working.Products.length) {
                    filtered.push(working)
                }
            }

            this.configuratorProductsFiltered = filtered
          },
          checkAndUpdateChildRowsQuantity(parentId, quantity){
              this.dataSource.forEach(row => {
                  if(row.parentId && row.parentId === parentId){
                      row.Quantity = quantity * row.parentRatio;
                  }
              })
          },
          capitalize(string){
              // console.log(string.charAt(0).toUpperCase() + string.slice(1))
              // return string.charAt(0).toUpperCase() + string.slice(1);
              return string.toUpperCase();
          },
          handleMemberSelected(){
              //let configuratorIndex = this.configurators.map(config => config.Id).indexOf(this.selectedConfiguratorId);
              //let memberIndex = this.configurators[configuratorIndex].ConfiguratorMembers.map(member => member.Id).indexOf(this.selectedMemberId);
              //this.selectedCategoryId = this.configurators[configuratorIndex].ConfiguratorMembers[memberIndex].Categories.sort(categorySort)[0].Id
              //this.getConfiguratorProducts();
          },
          handleSelectedConfigChange(){
              let configuratorIndex = this.configuratorOptions.map(config => config.Id).indexOf(this.selectedConfiguratorId);

              const member = this.configuratorOptions[configuratorIndex].member
              this.selectedMemberId = member.Id

              this.selectedCategoryId = member.Categories.sort(categorySort)[0].Id
              this.getConfiguratorProducts();
          },
          formatCurrency(currency){
              if(typeof(currency) !== 'number') return;
              return `$${currency.toFixed(2)}`;
          },
          clearDataSource(){
              this.dataSource = [];
              this.dataSourceUpdateKey++;
          },
          handleProductClicked(product){
              this.addProductToConfiguratorDataGrid(product);
          },
          updateQuantityForParentAndChildren(productId){
              let index = this.dataSource.map(row => row.Id).indexOf(productId)
              this.dataSource[index].Quantity++;
              let qty = this.dataSource[index].Quantity;
              this.dataSource.forEach(row => {
                  if(row.parentId === productId){
                      row.Quantity = qty * row.parentRatio;
                  }
              })
          },
          productAlreadyExists(productId){
              return this.dataSource.map(row => row.Id).indexOf(productId) >= 0;
          },
          addProductToConfiguratorDataGrid(product){
              if(this.productAlreadyExists(product.Id)){
                  this.updateQuantityForParentAndChildren(product.Id)
                  return;
              }
              let lineNumber = 0;
              
              this.dataSource.forEach(obj => {
                  if(obj.lineNumber >= lineNumber){
                      lineNumber = obj.lineNumber+1;
                  }
              })
              let productWithoutSubproducts = {...product}
              productWithoutSubproducts.Quantity = productWithoutSubproducts.Quantity || 1 ;
              delete productWithoutSubproducts.Subproducts
              this.dataSource.push({
                  ...productWithoutSubproducts,
                  lineNumber: lineNumber
              }) 
              lineNumber++;
              if(product.Subproducts){
                  product.Subproducts.forEach(Subproduct => {
                      Subproduct.Quantity = Subproduct.Quantity || 1;
                      let parentQuantity = productWithoutSubproducts.Quantity;
                      let childQuantity = Subproduct.Quantity;
                      let parentRatio = childQuantity/parentQuantity;
                      this.dataSource.push({...Subproduct, lineNumber: lineNumber, parentId: productWithoutSubproducts.Id, parentRatio: parentRatio});
                      lineNumber++;
                  })
              }
          },
          getConfigurators(){
              DealerService.configurators().then(res => {
                this.configurators = res

                const options = []
                for ( const config of this.configurators ) {
                    for ( const member of config.ConfiguratorMembers ) {
                        let name = config.ConfiguratorName
                        if (name.toUpperCase() !== member.Name.toUpperCase()) {
                            name += ` (${member.Name})`
                        }

                        options.push({
                            Id: config.Id + ' - ' + member.Id,
                            ConfiguratorName: name,
                            ConfiguratorLogoUrl: config.ConfiguratorLogoUrl,
                            configurator: config,
                            member,
                        })
                    }
                }

                this.configuratorOptions = options

                //console.debug('CONFIGURATORS: ', res)
                this.selectedConfiguratorId = options[0].Id;
                //this.selectedMemberId = res[0].ConfiguratorMembers[0].Id;

                //this.selectedCategoryId = res[0].ConfiguratorMembers[0].Categories.sort(categorySort)[0].Id
                this.selectedCategoryId = options[0].member.Categories.sort(categorySort)[0].Id
                
                this.getConfiguratorProducts();
              }).catch(err => {
                  console.error(err);
              })
          },
          getConfiguratorProducts(){
            var sendDate = (new Date()).getTime();

            this.search = ''
              this.configuratorProducts = []
              DealerService.configuratorsProducts(this.selectedCategoryId).then(res => {

                var receiveDate = (new Date());
                var responseTimeMs = receiveDate - sendDate;

                  this.configuratorProducts = res;
                  this.configuratorProductsFiltered = res;
              }).catch(err => {
                  console.error(err);
              })
          },  
          handleAddToOrderlinesClicked(){
              this.addToOrderlinesWasClicked = true;
          },
          handleAddProducts(){
              this.$emit('productsAdded', this.dataSource)
              this.clearDataSource()
              this.addToOrderlinesWasClicked = false;
          },
          async getAllProducts() {
            var sendDate = (new Date()).getTime();

            DealerService.configuratorAllProducts().then(res => {
                this.allProducts = res;
                var receiveDate = (new Date());
                var responseTimeMs = receiveDate - sendDate;

                console.log('All Products Timing: ' + responseTimeMs);
                //console.log('Got all products: ', this.allProducts);
              }).catch(err => {
                console.error(err);
              });
          }
      },
      mounted(){
          this.getConfigurators();
          this.getAllProducts();
      },
  }
</script>

<style scoped lang="scss">
  .config-wrapper{
      max-width: 1200px;
      // min-width: 1000px;
  }
  .image{
      max-width: 150px;
      max-height: 150px
  }
  .icon-btn{
      border: none;
      background-color: transparent;
      padding: 0px;
  }
  .thumbnail-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 10px;
      min-height: 100px;
  }
  .configurator-name-wrapper{
      display: flex;
      flex-direction: column
  }
  .configurator-group-wrapper{
      background-color: white;
      border: solid 1px $ss-grey2;
      // min-width: 400px;
      // min-height: 450px;
      height: 30vh;
      max-height: 30vh;
      overflow: scroll;
      .group-container:hover{
          background-color: rgba(0,0,0,.05);
      }
      .product-container:hover{
          background-color: $secondary;
      }
  }
  .product-datagrid-wrapper {
      /*max-height: 200px;*/
      //padding: 10px;
      margin-top: -15px;
  }
  .total{
      color: $primary;
      font-size: 28px;
  }
  .form-group{
      margin-bottom: 0px;

      select {
          -webkit-appearance: none;
          -moz-appearance: none;
          -o-appearance: none;
          /* no standardized syntax available, no ie-friendly solution available */
      }
      select + i.fa {
          float: right;
          margin-top: -26px;
          margin-right: 5px;
          /* this is so when you click on the chevron, your click actually goes on the dropdown menu */
          pointer-events: none;
          background:transparent;
          /* everything after this is just to cover up the original arrow */
          /* (for browsers that don't support the syntax used above) */
          /*background-color: #fff; inherits from form-control*/
          padding-right: 5px;
      }
  }
</style>
